export default __webpack_public_path__ + "static/media/15_dolbit.0d3cc1a4.JPG";